import { render, staticRenderFns } from "./PaginatedResearchNodeList.vue?vue&type=template&id=3e26241c"
import script from "./PaginatedResearchNodeList.vue?vue&type=script&lang=ts"
export * from "./PaginatedResearchNodeList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports